__webpack_require__.p = "https://static.lemanapro.ru/microfronts/p0501/landings/";